module.exports = __webpack_public_path__ + "img/icon-close.c4cf5dec.svg";